import { render, staticRenderFns } from "./ReporteIncidencias.vue?vue&type=template&id=68002601&"
import script from "./ReporteIncidencias.vue?vue&type=script&lang=js&"
export * from "./ReporteIncidencias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports